module.exports = __webpack_public_path__ + "static/media/img_6.c513d8c6.JPG";